module.exports = __webpack_public_path__ + "img/logo_xintong.8e43ab25.png";